import React from 'react';
import { useTranslation } from 'react-i18next';

const Messages = () => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col justify-center items-center h-full w-full bg-white p-6 rounded-br-3xl text-gray-600 space-y-2 overflow-y-auto">
      <h2 className="text-lg font-bold">{t('dashboard.messages')}</h2>
      <p>{t('common.wip')}</p>
      {/* Messages items will be rendered here */}
    </div>
  );
};

export default Messages;
